import {
  Box, CloseButton, Flex,
  IconButton,
  Image as ChakraImage,
  Spacer
} from '@chakra-ui/react'
import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import LeftArrow from '../../../graphics/navbar/LeftArrow'
import RightArrow from '../../../graphics/navbar/RightArrow'
import { colors } from '../../../ui-kit'
import { NavBar, NavBarProfile } from '../../components/NavBar'
import { NavBarContext, UserContext } from '../../providers'

const NavBarLayoutWrapper = styled(Box) <{ open: boolean }>`
  ${props => (props.open ? 'width: 260px;' : 'width: 72px;')}
  height: 100vh;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.12);
  background-color: ${colors.appDarkIndigo};
  display: flex;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -o-user-select: none;
  transition: width 300ms ease-in-out;
`

const NavBarWrapper = styled(Box)`
  color: ${colors.appWhite};
  width: 100%;
  border: none;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

const StyledIconButton = styled(IconButton) <{ open: boolean }>`
  background-color: ${colors.appSlate};
  opacity: ${props => (props.open ? '1' : '0.8')};
  transition: left var(--sidebarNavTransitionDuration) ease-in-out;
  left: ${props => (props.open ? '0' : '-26px')};
  z-index: 99;
`

const NavBarLayout = (_props) => {
  const { pathname } = useLocation()

  const { user } = useContext(UserContext)

  const { isOpen, onToggle } = useContext(NavBarContext)

  if (pathname === '/get-started') {
    return null
  }

  return (
    <NavBarLayoutWrapper open={isOpen}>
      <NavBarWrapper>
        <Flex
          justifyContent="space-between"
          style={{ gap: '32px', alignItems: 'center', padding: '1em 0.3em' }}
        >
          <Box flex="1" display={"flex"} style={{ gap: '10px', alignItems: "baseline" }}>
            <ChakraImage
              src="https://ikmedia.imagekit.io/logo/light-icon_GTyhLlWNX-.svg?updatedAt=1610958435591"
              alt="ImageKit logo"
              width="32px"
              style={{ borderRadius: "4px", maxWidth: "none" }}
            />
            <ChakraImage
              src="https://ikmedia.imagekit.io/logo/ikLogoWhite_30FbZCVusC.svg?updatedAt=1631077405708"
              alt="ImageKit logo"
              width="109px"
              maxWidth={"none"}
              display={isOpen ? 'block' : 'none'}
            />
          </Box>
          <StyledIconButton
            variant="unstyled"
            aria-label="Collapse Sidebar"
            display="flex"
            icon={isOpen ? <LeftArrow /> : <RightArrow />}
            isRound={true}
            size="sm"
            _focus={{
              boxShadow: 'none',
            }}
            open={isOpen}
            onClick={onToggle}
          />
        </Flex>
        <NavBar isOpen={isOpen} />
        <Spacer />
        <AnnoucementCenter isOpen={isOpen} />
        <NavBarProfile isOpen={isOpen} user={user} />
      </NavBarWrapper>
    </NavBarLayoutWrapper>
  )
}

const StyledAnnoucementCenter = styled.a <{ open: boolean, annoucementImageURL: string }>`
  border-radius: 12px;
  transition: height var(--sidebarNavTransitionDuration) ease-in-out,  width var(--sidebarNavTransitionDuration) ease-in-out;
  height: ${props => (props.open ? '154px' : '0')};
  width: ${props => (props.open ? '100%' : '0')};
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
  background: linear-gradient(107.38deg,rgba(202,217,239,0.3) 0%,rgba(202,217,239,0.1) 101.3%);
  background-image: url(${props => props.annoucementImageURL});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`
const AnnoucementCenter = ({ isOpen }: { isOpen: boolean }): React.ReactElement => {
  const [showAnnoucement, setShowAnnoucement] = useState(false);
  const [annoucementImageURL, setAnnoucementImageURL] = useState('');
  const [annoucementLink, setAnnoucementLink] = useState('');
  useEffect(() => {
    window.showAnnoucement = ({
      image,
      link
    }) => {
      if (!image || !link) {
        return;
      }

      // Check if the annoucement is closed in the last 24 hours
      const annoucementClosed = localStorage.getItem('annoucementClosed');
      if (annoucementClosed) {
        const { closed, timestamp } = JSON.parse(annoucementClosed);
        if (closed && (Date.now() - timestamp) < 24 * 60 * 60 * 1000) {
          return;
        }
      }

      setShowAnnoucement(true);
      setAnnoucementImageURL(image);
      setAnnoucementLink(link);
    };
    window.hideAnnoucement = () => {
      setShowAnnoucement(false);
    }
  }, []);

  const handleCloseAnnoucement = (e) => {
    e.preventDefault();
    setShowAnnoucement(false);

    localStorage.setItem('annoucementClosed', JSON.stringify({
      closed: true,
      timestamp: Date.now()
    }));
  };

  return (
    // add cross button to close the annoucement
    <>
      {showAnnoucement &&
        <StyledAnnoucementCenter open={isOpen} annoucementImageURL={annoucementImageURL} href={annoucementLink} target="_blank">
          <CloseButton size='sm' position={"absolute"} style={{
            right: "5px", top: "5px"
          }} onClick={handleCloseAnnoucement} />
        </StyledAnnoucementCenter>
      }
    </>
  )
}


export default NavBarLayout